import { apiClient } from "../apiClient";
import { IFinancialSummary } from "../../model/respone/financial/IFinancialSummary";

export const financialApi = {
    GetSummary: () => apiClient.get<IFinancialSummary>("registration/financial"),
};
